module.exports = __webpack_public_path__ + "f4bb19b0fcffa77313c30e10c47cd84f.png";